<div class="card">
  <div class="card-body">
      <h4 class="card-title">{{titolo}}</h4>
      <ngx-charts-advanced-pie-chart class="chart-container" [scheme]="colorScheme" [results]="single" (legendLabelClick)="onLegendLabelClick($event)"
          [gradient]="gradient" [tooltipDisabled]="tooltipDisabled" (select)="select($event)">
      </ngx-charts-advanced-pie-chart>
  </div>
</div>
